import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@volca/ui/components/ui/dropdown-menu";

// Cursor position and zero-based Glide index of the right-clicked header.
export interface ColumnHeaderMenuTarget {
  x: number;
  y: number;
  columnIndex: number;
}

interface ColumnHeaderMenuProps {
  target: ColumnHeaderMenuTarget | null;
  frozenColumn: number | null;
  isSaving: boolean;
  onClose: () => void;
  onFrozenColumnChange: (frozenColumn: number | null) => void;
}

export const ColumnHeaderMenu = ({
  target,
  frozenColumn,
  isSaving,
  onClose,
  onFrozenColumnChange,
}: ColumnHeaderMenuProps) => (
  <DropdownMenu
    open={target !== null}
    onOpenChange={(open, details) => {
      if (!open && details.reason === "focus-out") {
        details.cancel();
        return;
      }
      if (!open) onClose();
    }}
    modal={false}
  >
    <DropdownMenuTrigger
      nativeButton={false}
      render={
        <span
          aria-hidden
          className="pointer-events-none fixed h-0 w-0"
          style={{ left: target?.x ?? 0, top: target?.y ?? 0 }}
        />
      }
    />
    <DropdownMenuContent align="start" className="min-w-max">
      <DropdownMenuItem
        disabled={!target || isSaving}
        onClick={() => {
          if (target) onFrozenColumnChange(target.columnIndex + 1);
        }}
      >
        Freeze through this column
      </DropdownMenuItem>
      {frozenColumn !== null && (
        <>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            disabled={isSaving}
            onClick={() => onFrozenColumnChange(null)}
          >
            Unfreeze columns
          </DropdownMenuItem>
        </>
      )}
    </DropdownMenuContent>
  </DropdownMenu>
);
